module.exports = __webpack_public_path__ + "img/pic07@2x.e4a1c1fc.png";